/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React, { Component } from 'react'

import type { StackDeployment, AsyncRequestState, ClusterSnapshot } from '@modules/ui-types'

import SnapshotInProgress from '../Cluster/Snapshots/SnapshotInProgress'

type Props = {
  deployment: StackDeployment
  fetchSnapshots: () => void
  fetchSnapshotsRequest: AsyncRequestState
  snapshot: ClusterSnapshot | null
}

export default class DeploymentSnapshotProgress extends Component<Props> {
  componentDidMount() {
    const { fetchSnapshots } = this.props
    fetchSnapshots()
  }

  render() {
    const { deployment, fetchSnapshotsRequest, snapshot } = this.props

    if (fetchSnapshotsRequest.error) {
      return null
    }

    if (!snapshot) {
      return null
    }

    return (
      <SnapshotInProgress
        deployment={deployment}
        snapshot={snapshot}
        snapshotName={snapshot.snapshot}
      />
    )
  }
}
